import React, {useEffect, useState} from 'react';
import axios from 'axios';
import Header from "../../../components/layout/Header";
import Wrapper from "../../../components/layout/Wrapper";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBook,
    faCoins,
    faFire,
    faHandPaper,
    faPencil,
    faPerson
} from '@fortawesome/free-solid-svg-icons';
import Footer from "../../../components/layout/Footer";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import ProgressBar from "../../../components/elements/ProgressBar";
import ButtonLink from "../../../components/elements/ButtonLink";
import AccountMenu from "../AccountMenu";
import {useAuth} from "../../../context/AuthProvider";
import {COURSE_API_BASE, SITE_URL} from "../../../utils/apiConfig";
import AccountSidebar from "../AccountSidebar";
import {Helmet} from "react-helmet-async";

const MyCourses = () => {

    const {user} = useAuth();

    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);

    const breadC = [
        {title: 'حساب‌کاربری', link: '#'},
        {title: 'دوره‌های من', link: '/fa/account/course'},
    ];


    useEffect(() => {
        if (!user?.id) return;

        const getCourses = async () => {
            try {
                const response = await axios.get(
                    `${COURSE_API_BASE}/user/`,
                    {
                        withCredentials: true,
                    }
                );

                if (response.data.success) {
                    setCourses(response.data.courses || []);
                }
            } catch (error) {
                console.error('Failed to fetch user courses:', error);
            } finally {
                setLoading(false);
            }
        };

        getCourses();
    }, [user?.id]);


    return (
        <>
            <Helmet>
                <title>دوره‌های من | کدپرو</title>
            </Helmet>

            <div className='min-h-screen flex flex-col'>
                <Header/>

                <main className='flex-1 my-8'>
                    <Wrapper>
                        <div className='w-full flex flex-1 flex-col lg:flex-row gap-x-10'>

                            {user && (
                                <AccountSidebar
                                    name={user.name}
                                    phone_number={user.phone_number}
                                    credit={user.credit}
                                    streak={user.streak}
                                    xp={user.xp}
                                    character={user.character}
                                />
                            )}

                            <div className='w-full order-1 lg:order-2 lg:w-4/5'>

                                <Breadcrumb items={breadC} wrapper={false}/>

                                {loading ? (
                                    <div className='text-center py-10'>
                                        در حال بارگذاری دوره‌ها...
                                    </div>
                                ) : courses.length === 0 ? (
                                    <div className='text-center py-10'>
                                        هنوز در دوره‌ای ثبت‌نام نکرده‌اید.
                                    </div>
                                ) : (
                                    <div className='flex flex-col lg:flex-row flex-wrap gap-x-8 gap-y-8'>

                                        {courses.map((course) => (
                                            <div
                                                key={course.course_id}
                                                className='w-full lg:w-1/3 border-4 border-gray-200 rounded-md p-5'>

                                                <h2 className='text-xl font-bold mb-5 text-gray-700'>
                                                    {course.title}
                                                </h2>

                                                <ProgressBar
                                                    value={course.course_level}
                                                    max={course.total_levels}
                                                />

                                                <div className='flex mt-5 flex-1 justify-between items-center gap-x-3'>

                                                    <div className='w-1/2'>
                                                        <ButtonLink
                                                            to={`/fa/account/course/${course.course_id}/content`}
                                                            className='gap-x-2 w-full'>

                                                            <FontAwesomeIcon
                                                                icon={faBook}
                                                                size='lg'
                                                            />

                                                            <span className='font-bold'>
                                                            درسنامه
                                                        </span>

                                                        </ButtonLink>
                                                    </div>

                                                    {course.has_bought ? (
                                                        <div className="w-1/2">
                                                            <ButtonLink
                                                                to={`/fa/account/course/${course.course_id}/cheatsheet`}
                                                                className="gap-x-2 w-full">
                                                                <FontAwesomeIcon
                                                                    icon={faHandPaper}
                                                                    size="lg"/>

                                                                <span className="font-bold">تقلب‌نامه</span>
                                                            </ButtonLink>
                                                        </div>
                                                    ) : (
                                                        <div className="w-1/2">
                                                            <ButtonLink
                                                                to={`/fa/account/course/purchase/${course.course_id}`}
                                                                className="gap-x-2 w-full">
                                                                <FontAwesomeIcon
                                                                    icon={faCoins}
                                                                    size="lg"
                                                                />
                                                                <span className="font-bold">خرید دوره</span>
                                                            </ButtonLink>
                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                )}

                            </div>
                        </div>
                    </Wrapper>
                </main>

                <Footer/>
            </div>

        </>

    );
};

export default MyCourses;